export default
{
    // types: mail, facebook, twitter
    name: 'app-btn-share',

    props:
    {
        url: { type: String },
        title: { type: String },
        type: { type: String, default: 'mail' },
        content: { type: Object },
        size: { type: String, default: 'medium' }
    },

    created()
    {
        const link = document.createElement('a')
        link.href = this.url

        this._url = link.href
        this._message = this.content.content.replace(':url', this._url).replace(':title', this.title)
        this._subject = this.content.subject ? this.content.subject.replace(':url', this._url).replace(':title', this.title) : ''
    },

    methods:
    {
        _onClick(event)
        {
            let out = true


            switch (this.type)
            {
            case 'mail': {
                out = true
                this._pushToGTM()
                break
            }
            case 'facebook': {
                const url = this._getShareLink()
                this._openWindow(url)
                this._pushToGTM()
                event.preventDefault()
                out = false
                break
            }
            case 'twitter': {
                const url = this._getShareLink()
                this._openWindow(url)
                this._pushToGTM()
                event.preventDefault()
                out = false
                break
            }
            default:
                console.error('<app-btn-share> You can not click other links than email, Facebook or Twitter')
                /* case 'link':
                {
                    const url = this._getShareLink()
                    this._openWindow(url)
                    event.preventDefault()
                    return false
                    break
                }*/
            }

            return out
        },

        _openWindow(url)
        {
            window.open(url, '_blank', 'height=500,width=450,menubar=no,status=no,titlebar=no')
        },

        _getShareLink()
        {
            let url

            switch (this.type)
            {
            case 'mail':

                url = 'mailto:?Subject=' + encodeURIComponent(this._subject) + '&Body=' + encodeURIComponent(this._message)
                break

            case 'facebook':

                url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this._url)
                break

            case 'twitter':

                url = 'https://twitter.com/home?status=' + encodeURIComponent(this._message)
                break

            default:

                console.error('The component <app-btn-share> accept only types "mail", "facebook" or "twitter"')
            }

            return url
        },

        _pushToGTM()
        {
            if (window.dataLayer)
            {
                window.dataLayer.push({
                    event: 'gfinity.social',
                    'gfinity.social.network': this.type === 'mail' ? 'email' : this.type,
                    'gfinity.social.action': 'share',
                    'gfinity.social.resource': this._url
                })
            }
            else
            {
                console.error('Google Tag Manager: dataLayer not defined')
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/scripts/components/app-btn-share/script.js